export default "__VITE_ASSET__wIX8Ptl2__"